import React from "react";
import { Trans, useTranslation } from "react-i18next";

import BrandMark from "../components/BrandMark";

/**
 * Thin wrapper around react-i18next's <Trans /> that registers our standard
 * inline-tag vocabulary: <em>, <strong>, <br/>, <span>, <brand/>, and
 * <link>. Use for any string that contains inline HTML-ish markup.
 *
 * For a plain label with no tags, use `t(key)` directly.
 */
export default function I18nText({ i18nKey, values, components }) {
    const { t } = useTranslation();
    return (
        <Trans
            t={t}
            i18nKey={i18nKey}
            values={values}
            components={{
                em: <em />,
                strong: <strong />,
                br: <br />,
                span: <span />,
                brand: <BrandMark />,
                link: <span className="accent-link" />,
                ...(components || {}),
            }}
        />
    );
}
